import { FC, CSSProperties } from "react";
import { Button, Col, Row } from "antd";
import { BR, US, ES } from 'country-flag-icons/react/3x2';
import { useAppLanguage } from "../hooks/useAppLanguage";

export const IntlButtons: FC = () => {
  const { language, changeLanguage } = useAppLanguage();

  const color_br = language === "br" ? "#4096ff" : undefined;
  const color_en = language === "en" ? "#4096ff" : undefined;
  const color_es = language === "es" ? "#4096ff" : undefined;

  const flagStyle = (lang: string): CSSProperties => ({
    width: '20px',
    marginLeft: '8px',
    verticalAlign: 'middle',
    filter: language === lang ? 'none' : 'grayscale(100%)',
    opacity: language === lang ? 1 : 0.4,
  });

  return (
    <Row gutter={8} style={{ margin: 0 }}>
      <Col>
        <Button
          onClick={() => changeLanguage("br")}
          title="Brasil"
          type={language === "br" ? "default" : "dashed"}
          style={{ color: color_br, borderColor: color_br }}
        >
          Brasil <BR style={flagStyle('br')} />
        </Button>
      </Col>
      <Col>
        <Button
          onClick={() => changeLanguage("en")}
          title="English"
          type={language === "en" ? "default" : "dashed"}
          style={{ color: color_en, borderColor: color_en }}
        >
          Global <US style={flagStyle('en')} />
        </Button>
      </Col>
      <Col>
        <Button
          onClick={() => changeLanguage("es")}
          title="Español"
          type={language === "es" ? "default" : "dashed"}
          style={{ color: color_es, borderColor: color_es }}
        >
          Global <ES style={flagStyle('es')} />
        </Button>
      </Col>
    </Row>
  );
}
